<!-- 首页 -->
<template>
  <div class="home_layer" :class="images[currentIndex]">
    <div class="fixednav">
      <ul>
        <li @click="onChangeBg(0)" :class="currentIndex == 0 ? 'active' : ''">
          <div class="lefttext">
            <div class="dot" :class="currentIndex == 0 ? 'dotactive' : 'dotnotactive'"></div>
            <div>AI实训室</div>
          </div>
          <div v-show="currentIndex == 0" class="el-icon-caret-left"></div>
        </li>
        <li @click="onChangeBg(1)" :class="currentIndex == 1 ? 'active' : ''">
          <div class="lefttext">
            <div class="dot" :class="currentIndex == 1 ? 'dotactive' : 'dotnotactive'"></div>
            <div>业务场景工作流搭建</div>
          </div>
          <div v-show="currentIndex == 1" class="el-icon-caret-left"></div>
        </li>
        <li @click="onChangeBg(2)" :class="currentIndex == 2 ? 'active' : ''">
          <div class="lefttext">
            <div class="dot" :class="currentIndex == 2 ? 'dotactive' : 'dotnotactive'"></div>
            <div>应用场景落地</div>
          </div>
          <div v-show="currentIndex == 2" class="el-icon-caret-left"></div>
        </li>
        <li @click="onChangeBg(3)" :class="currentIndex == 3 ? 'active' : ''">
          <div class="lefttext">
            <div class="dot" :class="currentIndex == 3 ? 'dotactive' : 'dotnotactive'"></div>
            <div>一站式AI教学与考核</div>
          </div>
          <div v-show="currentIndex == 3" class="el-icon-caret-left"></div>
        </li>
      </ul>
    </div>
    <div class="fixedbottom">
      <img class="nextbg" src="~@imgs/jiantou4-copy_1.png" @click="nextBackground">
    </div>
    <div class="bgcontainer1" v-show="currentIndex == 0">
      <p class="p1">AI金融新纪元—智能体赋能金融数智化新生态</p>
      <p class="p2">AI Financial New Era—Intelligent Agents Empower the New Ecology of Financial Digital Intelligence
      </p>
    </div>
    <div class="bgcontainer2" v-show="currentIndex == 1">
      <div class="box box1">
        <div class="title">智能体开发能力</div>
        <div class="txt">依托FastGPT可视化工作流，学员完成智能体需求分析、知识库搭建、对话设计及测试全流程开发，掌握多模态交互技术，构建金融场景智能体应用。</div>
      </div>
      <div class="box box2">
        <div class="title">大模型应用能力</div>
        <div class="txt">基于实训室金融数据，学员掌握大语言模型在金融场景的定制调优与部署，通过prompt工程与模型微调，实现大模型从基础应用到业务适配的升级。</div>
      </div>
      <div class="box box3">
        <div class="title">模型评估与优化能力</div>
        <div class="txt">学员掌握AI模型性能评估指标，针对金融预测、风控等任务，通过调整参数、改进结构优化模型，提升其在金融场景的应用效果。</div>
      </div>
      <div class="box box4">
        <div class="title">场景应用能力</div>
        <div class="txt">学员在模拟金融场景中，将AI技术与客户服务、投资决策等板块结合，根据业务需求选择适配方案，实现技术落地与业务价值转化。</div>
      </div>
      <div class="box box5">
        <div class="title">数据分析与处理能力</div>
        <div class="txt">学员掌握金融数据清洗、转换与分析方法，运用工具挖掘市场与客户数据规律，为金融决策提供数据支撑。</div>
      </div>
    </div>
    <div class="bgcontainer3" v-show="currentIndex == 2">
      <div class="box box1">
        <div class="title">智能客服</div>
        <div class="txt">
          支持沉浸式交互场景，实现金融业务客服场景的高度仿真。学生可开展信用卡、理财、贷款等业务场景的问答实训，实现金融行业特定岗位的训练，获取AI及时评分与精准指导。
        </div>
      </div>
      <div class="box box2">
        <div class="title">智能保险推荐</div>
        <div class="txt">通过智能体模拟各类客户画像和保险需求，实现从客户需求分析、产品匹配到方案优化的全流程训练，智能体可实时生成推荐建议并动态调整方案。
        </div>
      </div>
      <div class="box box3">
        <div class="title">信用风险管理</div>
        <div class="txt">
          利用智能体模拟各类信贷业务场景与决策过程，结合动态信用评分模型、风险预警系统等，实现从客户信用评估、风险量化到贷后管理的全流程训练。
        </div>
      </div>
      <div class="box box4">
        <div class="title">反洗钱监测</div>
        <div class="txt">
          通过部署客户交易智能体、监管规则执行智能体等，动态模拟多样化客户交易行为、复杂洗钱手法及严格监管要求等，快速搭建定制化反洗钱监测模型。
        </div>
      </div>
      <div class="box box5">
        <div class="title">智能投研报告生成</div>
        <div class="txt">
          支持通过标准投研报告案例，掌握财务分析、估值模型等核心要素；系统将从数据准确性、分析深度等维度自动评分并提供优化建议。
        </div>
      </div>
      <div class="box box6">
        <div class="title">智能投顾</div>
        <div class="txt">
          支持在工作流搭建界面，选用大模型，配置马科维茨均值-方差模型等核心组件，设计“需求分析-方案生成-策略解释-动态调整”的服务逻辑链。
        </div>
      </div>
      <div class="box box7">
        <div class="title">信用卡反欺诈</div>
        <div class="txt">
          从典型案例切入，在工作流搭建界面选用大模型作为基座，同时构建风控知识库，配置消费模式识别等核心组件，并设定包含欺诈特征的规则提示词模板。实现信用卡智能风控实践的全流程贯通。
        </div>
      </div>
    </div>
    <div class="bgcontainer4" v-show="currentIndex == 3">
      <div class="txtboxs">
        <div class="line1">一站式</div>
        <div class="line2">
          <span class="ai">AI</span>
          <span>教学与考核</span>
        </div>
        <div class="line3">
          平台采用过程性与结果性双轨考核机制。过程性考核聚焦智能体开发全流程，针对模型选择、组件配置、逻辑链设计等关键环节评分，并在知识库构建、功能测试等节点审核反馈。结果性考核则通过模拟真实场景验证智能体性能。最终结合学员提交的成果文档与配置说明，综合评定对技术应用与业务逻辑的掌握水平。
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data () {
    return {
      projectName: window.ProjectTitle,
      images: [ // 背景图数组
        'bg1', 'bg2', 'bg3', 'bg4'
      ],
      scrollPosition: 0, // 滚动位置
      currentIndex: 0,//默认为第一个背景
      wheelTimeout: null
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    window.addEventListener('wheel', this.handleWheel);
  },
  beforeDestroy () {
    window.removeEventListener('wheel', this.handleWheel);
  },
  methods: {
    onChangeBg (num) {
      this.currentIndex = num
    },
    nextBackground () {
      this.currentIndex = (this.currentIndex + 1) % this.images.length
    },
    prevBackground () {
      this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length
    },
    handleWheel (e) {
      // 防止频繁滚动
      if (this.wheelTimeout) return;

      if (e.deltaY > 0) {
        this.nextBackground();

      } else {
        this.prevBackground();
      }

      this.wheelTimeout = setTimeout(() => {
        this.wheelTimeout = null;
      }, 800); // 800ms内不能再次切换
    },
  }
}
</script>

<style lang="less" scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.bg1 {
  background-image: url("/static/img/home-bg1.png") !important;
}

.bg2 {
  background-image: url("/static/img/home-bg2.png") !important;
}

.bg3 {
  background-image: url("/static/img/home-bg3.png") !important;
}

.bg4 {
  background-image: url("/static/img/home-bg4.png") !important;
}

.home_layer {
  height: 100%;
  min-width: var(--min-width);
  user-select: none;
  padding: 0 !important;
  background-color: transparent !important;
  backdrop-filter: none !important;
  display: flex;
  width: 100%;

  // background-size: cover;
  // background-position: center;
  background-size: 100% 100%;
  background-position: top;
  position: relative;


  .fixednav {
    position: fixed;
    left: 0;
    top: calc(50% - 80px);
    z-index: 2;

    ul {
      list-style: none;
      padding: 0;

      li {
        cursor: pointer;
        color: #fff;
        width: 1.8rem;
        height: 0.3rem;
        line-height: 0.3rem;
        padding: 0.05rem 0.5rem 0.05rem 0.2rem;
        margin: 0.1rem 0;
        display: flex;
        justify-content: space-between;
        align-items: center;


        // background: linear-gradient(to right, #000, #FFF);
        &.active {
          // background: linear-gradient(to right, #000, #7d879b);
          background: linear-gradient(to right, #0000005e, #5c647442, transparent);
          font-weight: bold;
          text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5q);
        }

        .lefttext {
          display: flex;
          align-items: center;

          .dot {
            width: 0.15rem;
            height: 0.15rem;
            border-radius: 50%;
            margin-right: 0.15rem;
          }

          .dotactive {
            background-color: #fff;
          }

          .dotnotactive {
            background-color: #a5a5a5;
            opacity: 0.5;
          }

        }

        .el-icon-caret-left {
          color: #fff;
        }
      }
    }
  }

  .fixedbottom {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 999;

    .nextbg {
      cursor: pointer;
      filter: drop-shadow(0 0 10px rgb(0, 145, 255));
      animation: floatAnimation 2s infinite ease-in-out;
    }

    /* 定义动画 */
    @keyframes floatAnimation {
      0% {
        transform: translateY(0);
        /* 起始位置 */
      }

      50% {
        transform: translateY(-20px);
        /* 中间位置，向上移动20px */
      }

      100% {
        transform: translateY(0);
        /* 结束位置 */
      }
    }
  }

  .bgcontainer1 {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    animation: fadeIn 2s forwards;

    .p1 {
      color: #fff;
      font-size: 40px;
      font-weight: bold;
      text-align: center;
      letter-spacing: 10px;
    }

    .p2 {
      color: #fff;
      font-size: 20px;
      text-align: center;
      letter-spacing: 1px;
    }
  }

  .bgcontainer2 {
    width: 100%;

    .box {
      position: absolute;
      width: 3rem;
      min-height: 1rem;
      background: rgba(255, 255, 255, 0.6);
      border-radius: 19px 19px 19px 19px;
      padding: 0.2rem;
      animation: fadeIn 2s forwards;


      .title {
        color: #1F83EB;
        margin-bottom: 0.1rem;
        text-align: center;
        font-weight: bold;
        font-size: 18px;
        letter-spacing: 5px;
      }

      .txt {
        color: #7b8089;
        font-size: 14px;
        line-height: 1.5;
        letter-spacing: 2px;
        text-indent: 2em;
      }
    }

    .box1 {
      top: 10%;
      left: 45%;
      transform: translate(-50%, -50%);
    }

    .box2 {
      top: 30%;
      left: 40%;
      transform: translate(-50%, -50%);
    }

    .box3 {
      top: 50%;
      left: 35%;
      transform: translate(-50%, -50%);
    }

    .box4 {
      top: 70%;
      left: 40%;
      transform: translate(-50%, -50%);
    }

    .box5 {
      top: 90%;
      left: 45%;
      transform: translate(-50%, -50%);
    }
  }

  .bgcontainer3 {
    width: 100%;

    .box {
      position: absolute;
      width: 3rem;
      min-height: 1rem;
      // background: rgba(255, 255, 255, 0.06);
      backdrop-filter: blur(20px);
      box-shadow: 0 0 30px 10px rgba(0, 0, 0, .1);
      border-radius: 19px 19px 19px 19px;
      padding: 0.2rem;
      animation: fadeIn 2s forwards;

      .title {
        color: #FFFFFF;
        margin-bottom: 0.1rem;
        text-align: center;
        font-weight: 600;
        font-size: 18px;
        letter-spacing: 5px;
      }

      .txt {
        // color: #FFFFFF;
        color: #d9e1ef;
        font-size: 14px;
        line-height: 1.5;
        opacity: 0.9;
        letter-spacing: 2px;
        text-indent: 2em;
      }
    }

    .box1 {
      top: 20%;
      left: 25%;
      transform: translate(-50%, -50%);
    }

    .box2 {
      top: 20%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .box3 {
      top: 20%;
      left: 75%;
      transform: translate(-50%, -50%);
    }

    .box4 {
      top: 50%;
      left: 35%;
      transform: translate(-50%, -50%);
    }

    .box5 {
      top: 50%;
      left: 65%;
      transform: translate(-50%, -50%);
    }

    .box6 {
      top: 80%;
      left: 25%;
      transform: translate(-50%, -50%);
    }

    .box7 {
      top: 80%;
      left: 75%;
      transform: translate(-50%, -50%);
    }
  }

  .bgcontainer4 {
    position: absolute;
    top: 40%;
    left: 40%;
    transform: translate(-50%, -50%);

    .txtboxs {
      width: 5rem;


      .line1 {
        font-size: 40px;
        margin-bottom: 0.3rem;
        animation: fadeIn 2s forwards;
        letter-spacing: 10px;
      }

      .line2 {
        font-size: 60px;
        margin-bottom: 0.3rem;
        animation: fadeIn 2.5s forwards;
        letter-spacing: 10px;

        .ai {
          color: #1c51fe;
          margin-right: 0.2rem;
        }
      }

      .line3 {
        line-height: 1.5;
        color: #505866;
        text-indent: 2em;
        animation: fadeIn 3s forwards;
        letter-spacing: 2px;
      }
    }
  }
}
</style>
